"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var tv4 = require('tv4');
var Band = /*#__PURE__*/function () {
  function Band(opt) {
    _classCallCheck(this, Band);
    this._id = null;
    this.name = null;
    this.suffix = null;
    this.family = [];
    this.cas = [];
    this.ghs = [];
    this.excludes = [];
    this.tenant = null;
    this.campus = null;
    this["class"] = null;
    this.hideFromUser = false;
    this.requireSop = [];
    this.useRules = false;
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(Band, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.name = opt.name || '';
      this.suffix = opt.suffix || null;
      this.family = opt.family ? opt.family.map(function (item) {
        return new ObjectId(item);
      }) : [];
      this.cas = opt.cas ? opt.cas : [];
      this.ghs = opt.ghs ? opt.ghs : [];
      this.excludes = opt.excludes ? opt.excludes.map(function (item) {
        return new ObjectId(item);
      }) : [];
      this.tenant = opt.tenant || 'GLOBAL';
      this.campus = opt.campus || 'GLOBAL';
      this["class"] = opt["class"] || null;
      this.hideFromUser = opt.hideFromUser || false;
      this.requireSop = opt.requireSop || [];
      this.useRules = !!opt.useRules;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Band.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'band.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          name: {
            type: 'string'
          },
          suffix: {
            type: ['string', 'null']
          },
          family: {
            type: 'array',
            item: {
              type: 'object'
            }
          },
          cas: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          ghs: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          excludes: {
            type: 'array',
            item: {
              type: 'object'
            }
          },
          tenant: {
            type: 'string'
          },
          campus: {
            type: 'string'
          },
          "class": {
            type: ['string', 'null']
          },
          hideFromUser: {
            type: 'boolean'
          },
          requireSop: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          useRules: {
            type: 'boolean'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return Band;
}();
module.exports = Band;